var CaseStudyCTASection = (function () {
  var promoBar, headerElem, content, productSect, sideDivWrapper, relatedPosts, allSectionHeadings, windowYOffset;
	return {
		init: init,
	};

  function init() {
    headerElem = document.getElementById("header-habitat"),
    content = document.querySelector('.cs-section-container'),
    productSect = document.querySelector('.cs-sidebar .cs-sidebar-info-product'),
    sideDivWrapper = document.querySelector('.cs-sidebar .cs-sidebar-csf-wrapper'),
    relatedPosts = document.getElementById('case-study-related-posts'),
    allSectionHeadings = document.querySelectorAll('.cs-block .cs-block-heading');
      
    
		uiBindings();
	}

  function uiBindings() {
    function handleScrollAndResizeEvents() {
      caseStudyStickyHeader();
      stickyProductsOnScroll();
      setArticleBoxPosition();
    }
    breadcrumbEvents();

    window.addEventListener('scroll', handleScrollAndResizeEvents);
    window.addEventListener('resize', handleScrollAndResizeEvents);

    if (allSectionHeadings.length > 0) {
      allSectionHeadings[0].parentElement.classList.add('cs-block-first');
    }
  }

  function caseStudyStickyHeader() {
    if (!headerElem.classList.contains('header-habitat--has-secondary-menu') && window.innerWidth > 979) {
      promoBar = document.getElementById('promo-notification');
      if (Cookie.read('closePromoNotification') && window.pageYOffset > 5) {
        document.body.classList.add('case-study-sticky-header');
      } else if (promoBar && window.pageYOffset > 51) {
        document.body.classList.add('case-study-sticky-header');
      } else if (window.pageYOffset >= 5 && !promoBar) {
        document.body.classList.add('case-study-sticky-header');
      } else {
        document.body.classList.remove('case-study-sticky-header');
      }
    } else {
      document.body.classList.remove('case-study-sticky-header');
    }
  }

  function stickyProductsOnScroll() {
    if (window.innerWidth >= 1280 && productSect) {
      var sidebar = document.querySelector('.cs-sidebar'),
        sidebarBottom = sidebar.getBoundingClientRect().bottom,
        windowYOffset = window.pageYOffset;

      if (windowYOffset <= content.offsetTop) {
        if (productSect.classList.contains('product-sticky') || productSect.classList.contains('product-bottom')) {
          productSect.classList.remove('product-sticky', 'product-bottom');
        }
      } else if ((sidebarBottom - 131) <= 0) {
        if (productSect.classList.contains('product-sticky') || productSect.classList.contains('product-bottom')) {
          productSect.classList.remove('product-sticky', 'product-bottom');
        }
      } else if ((windowYOffset > content.offsetTop) && ((windowYOffset + productSect.offsetHeight + sideDivWrapper.offsetHeight + 32 + 12) < (relatedPosts.offsetTop - 136))) {
        if (!productSect.classList.contains('product-sticky')) {
          productSect.classList.add('product-sticky');
          productSect.style.bottom = 'unset';
        }
        if (productSect.classList.contains('product-bottom')) {
          productSect.classList.remove('product-bottom');
        }
      } else {
        if (productSect.classList.contains('product-sticky')) {
          productSect.classList.remove('product-sticky');
        }
        if (!productSect.classList.contains('product-bottom')) {
          productSect.classList.add('product-bottom');
          productSect.style.bottom = sideDivWrapper.offsetHeight + 32 + 64 + "px"; //offset height + top margin + bottom spacing
        }
      }
    } else {
      productSect.classList.remove('product-sticky', 'product-bottom');
    }
  }

  function setArticleBoxPosition() {
    if (window.innerWidth >= 1280 && sideDivWrapper) {
      var sideDiv1 = document.querySelector('.cs-sidebar-csf-main'),
        contentHeight = Math.round(content.offsetHeight / 7),
        scrollPoint1x = content.offsetTop + contentHeight,
        windowYOffset = window.pageYOffset;
            
      sideDivWrapper.classList.add('cs-sidebar-csf-wrapper-sticky');
      sideDivWrapper.style.top = productSect.offsetHeight + 84 + "px";

      if (windowYOffset <= content.offsetTop) {
        sideDivWrapper.classList.remove('cs-sidebar-csf-wrapper-sticky', 'cs-sidebar-csf-wrapper-bottom');
      } else if (((sideDivWrapper.getBoundingClientRect().bottom) - 131) <= 0) {
        sideDivWrapper.classList.remove('cs-sidebar-csf-wrapper-sticky', 'cs-sidebar-csf-wrapper-bottom');
      } else if ((windowYOffset > content.offsetTop) && ((windowYOffset + productSect.offsetHeight + sideDivWrapper.offsetHeight) < (relatedPosts.offsetTop - 180))) {
        sideDivWrapper.classList.add('cs-sidebar-csf-wrapper-sticky');
        sideDivWrapper.classList.remove('cs-sidebar-csf-wrapper-bottom');
      } else {
        sideDivWrapper.classList.remove('cs-sidebar-csf-wrapper-sticky');
        sideDivWrapper.classList.add('cs-sidebar-csf-wrapper-bottom');
      }

      // Handle Sticky Divs Below TOC
      if (windowYOffset > scrollPoint1x) {
        sideDiv1.classList.add('cs-sidebar-csf-main-sticky');
      } else {
        sideDiv1.classList.remove('cs-sidebar-csf-main-sticky');
      }
    } else {
      sideDivWrapper.classList.remove('cs-sidebar-csf-wrapper-sticky', 'cs-sidebar-csf-wrapper-bottom');
    }
  }

  function breadcrumbEvents() {
    var linksElems = document.querySelectorAll('.doc-header-breadcrumbs-link, .cs-product-used, .cs-sidebar-product-used, .call-to-action__main a.btn');
    if (linksElems.length > 0) {
      for (var i = 0; i < linksElems.length; i++) {
        var ele = linksElems[i];
        ele.addEventListener('click', function (e) {
          var that = this,
            eventName = 'InteractedWithCaseStudyPage';
          if (that.closest('.doc-header-breadcrumbs')) {
            eventObj = {
              action: 'Breadcrumb click',
            };
          } else if (that.closest('.cs-product-used-wrapper')) {
            eventObj = {
              action: 'Product used click',
            };
          } else if (that.closest('.case-study-call-to-action')) {
            eventObj = {
              action: 'CTA click',
            };
          }
          eventObj.value = that.textContent;
            
          WebEventTracker.logEvent(EDS.webEvents, eventName, eventObj);
        });
      }
    }
  }
})();

CaseStudyCTASection.init();
